import React, { useState, useEffect } from 'react';

const MessageBox = ({ message, isError, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        if (onClose) onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!isVisible) return null;

  const bgColorClass = isError ? 'bg-red-500' : 'bg-green-500';

  return (
    <div id="messageBox" className={`fixed top-4 left-1/2 -translate-x-1/2 p-4 rounded-lg shadow-lg text-white font-bold transition-opacity duration-300 ${bgColorClass}`}>
      <p id="messageText">{message}</p>
    </div>
  );
};

export default MessageBox;
